
      var _path, _path2, _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCardEntity = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 43h89v12H17V43Z",
  fill: "var(--theme-primary, #9631FF)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M71 77h22",
  stroke: "var(--theme-primary, #9631FF)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 31,
  width: 88,
  height: 58,
  rx: 6,
  stroke: "#000",
  strokeWidth: 4.4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 64,
  width: 38,
  height: 38,
  rx: 19,
  fill: "#fff"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 64,
  width: 38,
  height: 38,
  rx: 19,
  stroke: "#000",
  strokeWidth: 4.4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#credit_card_entity_dcf59179d12bbb5f__a)",
  fill: "var(--theme-primary, #9631FF)",
  stroke: "var(--theme-primary, #9631FF)",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.124 91.651c.808.266 1.7-.064 2.038-.835l1.993-4.51c.358-.809-.078-1.75-.942-2.126l-.008-.003-.246-.082-.006-.003v.001c-.728-.187-1.496.094-1.85.722l-.065.13-.514 1.162-.018-.035c-.803-1.648-.963-3.473-.427-5.121l.15-.412c1.012-2.504 3.47-4.145 6.434-4.274l.17-.016c.841-.118 1.44-.833 1.333-1.676-.078-.604-.505-1.118-1.085-1.353a1.823 1.823 0 0 0-.563-.13l-.193-.001c-4.232.183-7.784 2.548-9.25 6.18-.988 2.448-.872 5.207.247 7.695l.001.001.019.04-1.136-.494-.008-.003-.246-.083-.006-.002c-.775-.2-1.597.135-1.916.852v.001c-.356.808.08 1.749.927 2.117l4.791 2.068.06.044.01.007.137.075.008.004.161.06ZM27.835 91.427c.11.871.937 1.522 1.84 1.484h.001c4.232-.184 7.784-2.549 9.25-6.18.988-2.448.872-5.206-.247-7.694v-.003l-.019-.036 1.104.478.146.059c.69.245 1.454.038 1.874-.499l.086-.12.003-.006.095-.18.003-.006.058-.153c.242-.77-.188-1.618-.983-1.963l-4.79-2.067-.064-.046-.01-.007v.001l-.15-.082-.008-.004-.009-.002-.245-.084-.007-.001c-.726-.187-1.493.092-1.841.706l-.064.126-2.012 4.548c-.355.806.078 1.746.912 2.11.843.387 1.848.058 2.206-.751l.512-1.163.02.037c.801 1.647.961 3.47.427 5.117l-.15.411-.099.233c-1.066 2.374-3.463 3.92-6.337 4.045-.928.04-1.616.794-1.502 1.692Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "credit_card_entity_dcf59179d12bbb5f__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "scale(1 -1) rotate(-21.984 -228.193 -73.113)",
  d: "M0 0h28v28H0z"
})))));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M17 43H106V55H17V43Z\" fill=\"var(--theme-primary, #9631FF)\"/>\r\n<path d=\"M71 77H93\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<rect x=\"17\" y=\"31\" width=\"88\" height=\"58\" rx=\"6\" stroke=\"black\" stroke-width=\"4.4\"/>\r\n<rect x=\"10\" y=\"64\" width=\"38\" height=\"38\" rx=\"19\" fill=\"white\"/>\r\n<rect x=\"10\" y=\"64\" width=\"38\" height=\"38\" rx=\"19\" stroke=\"black\" stroke-width=\"4.4\"/>\r\n<g clip-path=\"url(#clip0_18493_17621)\">\r\n<path d=\"M22.1241 91.6514C22.9324 91.9165 23.8232 91.5865 24.1623 90.8155L26.1546 86.3057C26.513 85.4973 26.0768 84.5555 25.2128 84.1804L25.2047 84.1771L24.9589 84.0947L24.9525 84.0922L24.9521 84.0931C24.2249 83.906 23.4574 84.1873 23.1032 84.8147L23.0379 84.9453L22.5237 86.1068L22.506 86.0723C21.7028 84.4241 21.543 82.5986 22.0786 80.951L22.2283 80.5386C23.2406 78.0351 25.6986 76.3941 28.6633 76.2647L28.8338 76.2493C29.6743 76.1314 30.2731 75.4158 30.1655 74.5732C30.0882 73.9685 29.6614 73.4546 29.0814 73.2204C28.9017 73.1478 28.7108 73.1032 28.5177 73.0907L28.3247 73.0887C24.0929 73.2724 20.541 75.6374 19.0746 79.2696C18.0866 81.7169 18.203 84.4758 19.3217 86.9636L19.3231 86.9652L19.3417 87.0053L18.2059 86.511L18.1977 86.5077L17.9519 86.4253L17.9456 86.4228C17.1707 86.2236 16.3491 86.5575 16.03 87.2755L16.0297 87.2764C15.6742 88.0842 16.1095 89.0245 16.9572 89.3927L21.7482 91.4607L21.8083 91.5049L21.818 91.512L21.8184 91.5111L21.9554 91.5865L21.9632 91.5906L22.1241 91.6514Z\" fill=\"var(--theme-primary, #9631FF)\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"0.2\"/>\r\n<path d=\"M27.8354 91.4273C27.9459 92.2984 28.7717 92.949 29.6753 92.9115L29.6762 92.9118C33.9081 92.7271 37.4602 90.3625 38.9263 86.7309C39.9145 84.2831 39.7978 81.5246 38.6793 79.0369L38.6782 79.0344L38.6603 78.9977L39.7637 79.4758L39.9104 79.535C40.5992 79.7803 41.3639 79.5734 41.7842 79.0361L41.8697 78.9158L41.8731 78.9098L41.9678 78.7301L41.9713 78.7241L42.0287 78.5714C42.2711 77.8012 41.8406 76.9529 41.0459 76.6076L36.2563 74.5413L36.1918 74.4952L36.182 74.4881L36.1816 74.489L36.0314 74.4073L36.0236 74.4031L36.0151 74.4007L35.7696 74.3174L35.7629 74.3157C35.0369 74.1288 34.2704 74.4083 33.9215 75.0215L33.8576 75.1484L31.8459 79.6957C31.4911 80.5022 31.9242 81.4424 32.7581 81.8058C33.6015 82.1934 34.6057 81.8636 34.9643 81.0547L35.4758 79.8921L35.4958 79.9286C36.2974 81.5755 36.4573 83.3992 35.9229 85.0455L35.7736 85.457L35.6744 85.6897C34.6075 88.0645 32.2112 89.6102 29.3367 89.7354C28.4086 89.7757 27.7207 90.5295 27.8354 91.4273Z\" fill=\"var(--theme-primary, #9631FF)\" stroke=\"var(--theme-primary, #9631FF)\" stroke-width=\"0.2\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_18493_17621\">\r\n<rect width=\"28\" height=\"28\" fill=\"white\" transform=\"matrix(0.927286 0.374353 0.374353 -0.927286 10.7773 90.7412)\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/credit_card_entity.dcf59179d12bbb5fef4c4bbf0eaebb82.svg"),
        {
          React: SvgCreditCardEntity,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      